<template>
    <div class="electronic-invoice">
        <div v-if="form.e_InviceIsCanceled && !form.foO_DIS_CNL" class="flex-block">
            <el-alert center :closable="false" type="error"> 本電子發票已於{{ invoicePlatform.label }}電子發票加值服務平台作廢，請自行作廢本申請單 </el-alert>
            <el-button v-if="isShowVoidBtn" class="button" size="small" @click="openVoid(true)"> 作廢 </el-button>
        </div>
        <div v-else-if="!isEInvoicePlatformMatch" class="flex-block">
            <el-alert center :closable="false" type="error"> 本電子發票與目前使用之電子發票平台不同，實際發票狀態請至{{ invoicePlatform.label }}電子發票加值服務平台查看 </el-alert>
        </div>
        <div v-else-if="isDeleteDateValidate && isBeforeSunPayChangeServerDate" class="flex-block">
            <el-alert center :closable="false" type="error">
                114/7/1 前由紅陽所開立的電子發票，如需作廢、折讓，請於 Sokuji操作後一併到
                <a href="https://oinv.sunpay.com.tw/" target="_blank">https://oinv.sunpay.com.tw/</a>
                平台再次操作一次
            </el-alert>
        </div>

        <div class="card-header">
            <div class="title">發票開立（電子發票）</div>
            <div class="actions">
                <span v-if="isShowDiscountButton" style="margin-left: 10px">
                    <!-- 銷貨折讓按鈕 -->
                    <span v-if="isEnableDiscountButton">
                        <el-button size="mini" :loading="isLoading" @click="openDiscount">銷貨折讓</el-button>
                    </span>
                    <span v-else style="margin-left: 10px">
                        <el-tooltip content="您無操作銷貨折讓權限，請聯絡財務人員操作。" placement="top">
                            <el-button disabled size="mini">銷貨折讓</el-button>
                        </el-tooltip>
                    </span>
                    <!-- 作廢按鈕 -->
                    <span v-if="isEnableDiscountButton" style="margin-left: 10px">
                        <span v-if="isDeleteDateValidate">
                            <el-button size="mini" @click="openVoid">作廢</el-button>
                        </span>
                        <span v-else>
                            <el-tooltip content="已超過此發票可作廢的日期。" placement="top">
                                <el-button disabled size="mini">作廢</el-button>
                            </el-tooltip>
                        </span>
                    </span>
                    <span v-else style="margin-left: 10px">
                        <el-tooltip content="您無操作作廢權限，請聯絡財務人員操作。" placement="top">
                            <el-button disabled size="mini">作廢</el-button>
                        </el-tooltip>
                    </span>
                </span>
            </div>
        </div>
        <div class="card-body">
            <el-row :gutter="40">
                <el-col :sm="14">
                    <spec-view>
                        <spec-item label="發票號碼">
                            <ahReceiptNumber :v="form.foo" />
                        </spec-item>
                        <spec-item label="發票日期">
                            {{ form.e_InvoiceDate | dateFormater("YYYY-MM-dd") }}
                        </spec-item>
                        <spec-item label="買受人名稱"> {{ form.e_InvoiceBuyerName }} </spec-item>
                        <spec-item label="買受人統編">
                            {{ form.e_InvoiceBuyeBSN }}
                        </spec-item>
                        <spec-item label="買受人E-mail">
                            {{ form.e_InvoiceBuyerEmail || "--" }}
                        </spec-item>
                        <spec-item label="買受人地址">
                            {{ form.e_InvoiceBuyerAddress || "--" }}
                        </spec-item>
                        <spec-item label="自訂編號"> {{ form.e_InvoiceOrderNo }} </spec-item>
                        <spec-item label="開立平台">
                            <span class="invoice-platform">
                                <a :href="invoicePlatform.href" target="_blank">
                                    {{ invoicePlatform.label }}
                                </a>
                            </span>
                        </spec-item>
                        <spec-item v-if="form.cny !== 'TWD'" label="匯率">
                            {{ form.rat }}
                        </spec-item>
                        <spec-item v-if="form.cny !== 'TWD'" label="約當台幣">
                            {{ twdAmt }}
                        </spec-item>
                        <spec-item label="開立備註">
                            {{ form.comment }}
                        </spec-item>
                    </spec-view>
                </el-col>
                <el-col :sm="10">
                    <spec-view>
                        <spec-item label="開立人">
                            {{ form.foO_CRT_NAM }}
                        </spec-item>
                        <spec-item label="填寫日期">
                            {{ form.foO_CRT_DAT | dateFormater("YYYY-MM-dd") }}
                        </spec-item>
                        <spec-item label="營業稅申報" v-if="is401Avaliable">
                            <el-tag v-if="form.declared" type="success" size="small">
                                <i class="el-icon-check" />
                                已申報
                                {{ getPeriodText(form.prefiX_YER, form.prefiX_MONTH) }}
                            </el-tag>
                            <span v-else>(未申報)</span>
                        </spec-item>
                    </spec-view>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { isBeforeSunPayChangeServerDate } from '@/utils/helpers';

import SpecView from '@/components/ui/SpecView/SpecView.vue';
import SpecItem from '@/components/ui/SpecView/SpecItem.vue';
import { eInvoicePlatformInfo } from '@/assets/commonData/options';
import ahReceiptNumber from '@/components/ui/ahReceiptNumber.vue';

export default {
    props: {
        form: {
            type: Object,
            default: () => {},
        },
        isDeleteDateValidate: Boolean,
    },
    components: { SpecView, SpecItem, ahReceiptNumber },
    data() {
        return {
            isLoading: false,
        };
    },
    computed: {
        isEditable() {
            if (this.isAuthOne(['B02', 'B03']) && (this.form.status === 2 || this.form.status === 3)) {
                return true;
            }
            return false;
        },
        // isShowDiscountButton() {
        //     if (!this.form) return false;
        //     if (this.form.e_InviceIsCanceled) return false;
        //     return this.form.foO_DIS_DAT === null && this.isAuthOne(['B03']);
        // },
        isShowDiscountButton() {
            if (!this.form) return false;
            if (this.form.e_InviceIsCanceled) return false;
            if (this.form.foO_DIS_DAT !== null) return false;
            return true;
        },
        isEnableDiscountButton() {
            return this.isAuthOne(['B03']);
        },
        isEInvoicePlatformMatch() {
            switch (this.eInvoicePlatform) {
            case 'EZPay':
                return this.form.e_InvoicePlatform === 1;
            case 'SunPay':
                return this.form.e_InvoicePlatform === 2;
            default:
                return false;
            }
        },
        invoicePlatform() {
            switch (this.form.e_InvoicePlatform) {
            case 1:
                return eInvoicePlatformInfo.ezPay;
            case 2:
                return eInvoicePlatformInfo.sunPay;
            default:
                return eInvoicePlatformInfo.none;
            }
        },
        isShowVoidBtn() {
            return !this.form.foO_DIS_DAT && (this.form.status === 1 || this.form.status === 2 || this.form.status === 3) && this.isAuthOne(['B02', 'B03']);
        },
        eInvoicePlatform() {
            return this.$store.getters['menu/companyInfo'].eInvoiceInfo?.platform;
        },
        is401Avaliable() {
            if (this.form.foO_CNL && !this.form.foO_DIS_CNL) return false;
            if (this.isAuth('G03') && this.isPayed('G03')) return true;
            return false;
        },
        twdAmt() {
            return Math.round(this.form.amt * this.form.rat).toLocaleString('en');
        },

        isBeforeSunPayChangeServerDate() {
            return isBeforeSunPayChangeServerDate(this.eInvoicePlatform, this.form.e_InvoiceDate);
        },
    },
    methods: {
        formatFoo(foo) {
            return `${foo.slice(0, 2)}-${foo.slice(2)}`;
        },
        openDiscount() {
            this.$emit('openDiscount');
        },
        openVoid() {
            this.$emit('openVoid');
        },
        getPeriodText(year, month) {
            const monthList = ['1~2月', '3~4月', '5~6月', '7~8月', '9~10月', '11~12月'];
            if (year > 1911 && month >= 0 && month < 12) {
                return `${year - 1911}年 ${monthList[month - 1]}`;
            }
            return '';
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.electronic-invoice {
    .invoice-platform a {
        color: $main-color;
        text-decoration: none;
    }
    .flex-block {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        .button {
            margin-left: 10px;
        }
    }
}
</style>
